document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-arrivals-open]');
  const section = button?.closest('[data-about-product-grid]') || (button?.closest('.about-catalogue-card') ? document.querySelector('[data-about-catalogue-panel]') : null);
  if (!section || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const panel = section.querySelector('about-cart-related[data-context="catalogue"]');
  if (typeof panel?.openCatalogueProduct !== 'function') return;
  event.preventDefault();
  panel.openCatalogueProduct(button, {
    id: button.dataset.productId,
    title: button.dataset.productTitle,
    url: button.href,
    price: Number(button.dataset.productPrice),
    price_varies: button.dataset.priceVaries === 'true'
  });
});
